(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bestiksaet-editorial-product"]) return;
  try {
    
  (() => {
    const page = document.querySelector('[data-bsk-pdp]');
    if (!page || page.dataset.ready === 'true') return;
    page.dataset.ready = 'true';

    const thumbs = Array.from(page.querySelectorAll('[data-media-index]'));
    const panels = Array.from(page.querySelectorAll('[data-media-panel]'));
    const imageStack = page.querySelector('.bsk-pdp-image-stack');
    let mediaRequestId = 0;

    const waitForImageLoad = (image) => {
      if (image.complete) return Promise.resolve(image.naturalWidth > 0);
      return new Promise((resolve) => {
        const finish = (loaded) => {
          image.removeEventListener('load', handleLoad);
          image.removeEventListener('error', handleError);
          resolve(loaded);
        };
        const handleLoad = () => finish(image.naturalWidth > 0);
        const handleError = () => finish(false);
        image.addEventListener('load', handleLoad);
        image.addEventListener('error', handleError);
        if (image.complete) finish(image.naturalWidth > 0);
      });
    };

    const decodeImage = async (image) => {
      if (typeof image.decode !== 'function') return image.naturalWidth > 0;
      try {
        await image.decode();
      } catch {
        return image.complete && image.naturalWidth > 0;
      }
      return image.naturalWidth > 0;
    };

    const prepareImage = async (panel) => {
      const image = panel.querySelector('img');
      if (!image) return true;
      image.loading = 'eager';
      image.fetchPriority = 'high';
      let loaded = await waitForImageLoad(image);
      if (loaded) return decodeImage(image);

      const fallback = panel.dataset.mediaFallback;
      if (!fallback) return false;
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src = fallback;
      loaded = await waitForImageLoad(image);
      if (!loaded) return false;
      return decodeImage(image);
    };

    const activateMedia = (thumb, panel) => {
      thumbs.forEach((item) => {
        const isActive = item === thumb;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-pressed', String(isActive));
      });
      panels.forEach((item) => {
        const isActive = item === panel;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-hidden', String(!isActive));
        item.inert = !isActive;
        if (!isActive) {
          item.querySelectorAll('video').forEach((video) => video.pause());
        }
      });
      panel.querySelector('video')?.play().catch(() => {});
    };

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', async () => {
        const index = thumb.dataset.mediaIndex;
        const panel = panels.find((item) => item.dataset.mediaPanel === index);
        if (!panel) return;

        const requestId = ++mediaRequestId;
        if (panel.classList.contains('is-active')) {
          imageStack?.removeAttribute('aria-busy');
          return;
        }

        if (panel.querySelector('img')) {
          imageStack?.setAttribute('aria-busy', 'true');
          const ready = await prepareImage(panel);
          if (requestId !== mediaRequestId) return;
          imageStack?.removeAttribute('aria-busy');
          if (!ready) return;
        } else {
          imageStack?.removeAttribute('aria-busy');
        }

        activateMedia(thumb, panel);
      });
    });

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const hero = page.querySelector('.bsk-pdp-hero');
    const accordions = Array.from(page.querySelectorAll('.bsk-pdp-accordion'));
    const syncAccordionLayout = () => {
      hero?.classList.toggle('has-open-accordion', accordions.some((item) => item.open));
    };
    syncAccordionLayout();
    accordions.forEach((accordion) => {
      const summary = accordion.querySelector('summary');
      const content = accordion.querySelector('.bsk-pdp-accordion__content');
      if (!summary || !content) return;

      summary.addEventListener('click', (event) => {
        event.preventDefault();
        if (accordion.hasAttribute('data-animating')) return;

        const isOpening = !accordion.open;
        if (reduceMotion.matches || typeof content.animate !== 'function') {
          accordion.open = isOpening;
          syncAccordionLayout();
          return;
        }

        accordion.setAttribute('data-animating', '');
        if (isOpening) {
          accordion.open = true;
          syncAccordionLayout();
        }

        const contentHeight = content.scrollHeight;
        const animation = content.animate(
          isOpening
            ? [
                { height: '0px', opacity: 0, transform: 'translateY(-6px)' },
                { height: `${contentHeight}px`, opacity: 1, transform: 'translateY(0)' }
              ]
            : [
                { height: `${contentHeight}px`, opacity: 1, transform: 'translateY(0)' },
                { height: '0px', opacity: 0, transform: 'translateY(-6px)' }
              ],
          {
            duration: isOpening ? 280 : 220,
            easing: 'cubic-bezier(.22, 1, .36, 1)'
          }
        );

        const finish = () => {
          if (!isOpening) accordion.open = false;
          accordion.removeAttribute('data-animating');
          syncAccordionLayout();
        };
        animation.addEventListener('finish', finish, { once: true });
        animation.addEventListener('cancel', finish, { once: true });
      });
    });

    const designerToggle = page.querySelector('[data-designer-toggle]');
    const designerText = designerToggle
      ? document.getElementById(designerToggle.getAttribute('aria-controls'))
      : null;
    if (designerToggle && designerText) {
      designerToggle.addEventListener('click', () => {
        const isExpanded = designerToggle.getAttribute('aria-expanded') === 'true';
        designerToggle.setAttribute('aria-expanded', String(!isExpanded));
        designerText.classList.toggle('is-collapsed', isExpanded);
        const label = designerToggle.querySelector('[data-designer-toggle-label]');
        if (label) {
          label.textContent = isExpanded
            ? designerToggle.dataset.moreLabel
            : designerToggle.dataset.lessLabel;
        }
      });
    }

    const form = page.querySelector('[data-product-form]');
    if (!form) return;

    const addToCartLabel = page.dataset.addToCartLabel || 'Add to cart';
    const soldOutLabel = page.dataset.soldOutLabel || 'Sold out';
    const unavailableLabel = page.dataset.unavailableLabel || 'Unavailable';

    const variantId = form.querySelector('[data-variant-id]');
    const price = page.querySelector('[data-product-price]');
    const priceCurrent = price?.querySelector('[data-product-price-current]');
    const priceCurrentLabel = price?.querySelector('[data-product-price-current-label]');
    const priceCompare = price?.querySelector('[data-product-price-compare]');
    const priceCompareValue = price?.querySelector('[data-product-price-compare-value]');
    const atc = form.querySelector('[data-atc]');
    const atcText = form.querySelector('[data-atc-text]');
    const atcPrice = form.querySelector('[data-atc-price]');
    const included = form.querySelector('[data-current-contents]');
    const selectedPieces = form.querySelector('[data-selected-pieces]');
    const variantInputs = Array.from(form.querySelectorAll('[data-variant-input]'));
    const optionInputs = Array.from(form.querySelectorAll('[data-bsk-option-input]'));
    const variantDataNode = form.querySelector('[data-bsk-variant-data]');

    const compactPrice = (value) =>
      String(value || '')
        .replace(/([,.])00$/, '')
        .replace(/(\d)[\s\u00a0\u202f](?=\d)/g, '$1');

    const updateProductPrice = (currentPrice, comparePrice = '', onSale = false) => {
      if (priceCurrent) priceCurrent.textContent = compactPrice(currentPrice);
      if (priceCurrentLabel) {
        priceCurrentLabel.textContent = `${onSale ? price.dataset.salePriceLabel : price.dataset.priceLabel}:`;
      }
      if (priceCompareValue) priceCompareValue.textContent = compactPrice(comparePrice);
      if (priceCompare) priceCompare.hidden = !onSale;
    };

    if (optionInputs.length && variantDataNode) {
      const variants = JSON.parse(variantDataNode.textContent || '[]');
      const groups = Array.from(form.querySelectorAll('[data-option-group]')).sort(
        (left, right) => Number(left.dataset.optionPosition) - Number(right.dataset.optionPosition)
      );

      const selectedValues = () => groups.map((group) => group.querySelector('[data-bsk-option-input]:checked')?.value || '');

      const updateOptionAvailability = () => {
        const selected = selectedValues();
        groups.forEach((group, groupIndex) => {
          const inputs = Array.from(group.querySelectorAll('[data-bsk-option-input]'));
          inputs.forEach((input) => {
            const isAvailable = variants.some((variant) => {
              if (!variant.available || variant.options[groupIndex] !== input.value) return false;
              return variant.options.slice(0, groupIndex).every((value, index) => value === selected[index]);
            });
            input.disabled = !isAvailable;
            input.closest('.bsk-pdp-option__value')?.classList.toggle('is-unavailable', !isAvailable);
          });

          const checked = inputs.find((input) => input.checked);
          if (!checked || checked.disabled) {
            const fallback = inputs.find((input) => !input.disabled);
            if (fallback) fallback.checked = true;
          }
          selected[groupIndex] = inputs.find((input) => input.checked)?.value || '';
        });
      };

      const applySelectedVariant = () => {
        updateOptionAvailability();
        const selected = selectedValues();
        const variant = variants.find(
          (candidate) => candidate.available && candidate.options.every((value, index) => value === selected[index])
        );
        optionInputs.forEach((input) => {
          input.closest('.bsk-pdp-option__value')?.classList.toggle('is-selected', input.checked);
        });
        if (!variant) {
          atc.disabled = true;
          atcText.textContent = unavailableLabel;
          return;
        }
        variantId.value = variant.id;
        updateProductPrice(variant.price, variant.comparePrice, variant.onSale);
        atcPrice.textContent = variant.price;
        atc.disabled = false;
        atcText.textContent = addToCartLabel;
        if (included) included.innerHTML = variant.contentsHtml || '';
        if (selectedPieces) selectedPieces.textContent = variant.pieces || variant.options[0] || '';
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        url.searchParams.delete('set-size');
        window.history.replaceState({}, '', url);
      };

      const requestedSetSize = new URL(window.location.href).searchParams.get('set-size');
      if (requestedSetSize && groups[0]) {
        const requestedInput = Array.from(groups[0].querySelectorAll('[data-bsk-option-input]')).find(
          (input) => input.value === requestedSetSize
        );
        if (requestedInput) requestedInput.checked = true;
      }

      optionInputs.forEach((input) => input.addEventListener('change', applySelectedVariant));
      applySelectedVariant();
    }

    variantInputs.forEach((input) => {
      input.addEventListener('change', () => {
        if (!input.checked) return;
        variantId.value = input.value;
        updateProductPrice(
          input.dataset.variantPrice,
          input.dataset.variantComparePrice,
          input.dataset.variantOnSale === 'true'
        );
        atcPrice.textContent = input.dataset.variantPrice;
        const available = input.dataset.variantAvailable === 'true';
        atc.disabled = !available;
        atcText.textContent = available ? addToCartLabel : soldOutLabel;
        if (included) included.innerHTML = input.dataset.variantContentsHtml || '';
        if (selectedPieces) selectedPieces.textContent = input.dataset.variantOptionValues || input.dataset.variantTitle || '';
        variantInputs.forEach((variantInput) => {
          variantInput.closest('.bsk-pdp-variant')?.classList.toggle('is-selected', variantInput === input);
        });
        const url = new URL(window.location.href);
        url.searchParams.set('variant', input.value);
        url.searchParams.delete('set-size');
        window.history.replaceState({}, '', url);
      });
    });

    const requestedVariantTitle = new URL(window.location.href).searchParams.get('set-size');
    if (requestedVariantTitle && variantInputs.length) {
      const requestedVariantInput = variantInputs.find(
        (input) => input.dataset.variantTitle === requestedVariantTitle
      );
      if (requestedVariantInput && !requestedVariantInput.disabled) {
        requestedVariantInput.checked = true;
        requestedVariantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bestiksaet-header"]) return;
  try {
    
  (() => {
    const header = document.querySelector('[data-bestiksaet-header]');
    if (!header || header.dataset.initialized === 'true') return;
    header.dataset.initialized = 'true';

    const body = document.body;
    const megaWraps = Array.from(header.querySelectorAll('.nav-item-wrap'));
    const cartDrawer = header.querySelector('#cartDrawer');
    const cartTriggers = header.querySelectorAll('.cart-trigger');
    const cartClose = header.querySelector('.cart-close');
    const mobileOpen = header.querySelector('.mobile-open');
    const mobileSearchTrigger = header.querySelector('.mobile-search-trigger');
    const mobileClose = header.querySelector('.mobile-close');
    const mobileMega = header.querySelector('.mobile-mega');
    const mobileSearchInput = header.querySelector('.mobile-search input');
    const dim = header.querySelector('[data-bsk-close]');
    const predictiveSearch = header.querySelector('[data-header-predictive-search]');
    let cartRequest;
    let closeHeaderSearch = () => {};
    let lastMobileTrigger = mobileOpen;

    function closeMegaMenus() {
      megaWraps.forEach((wrap) => {
        wrap.classList.remove('is-open');
        wrap.querySelector('.nav-item')?.setAttribute('aria-expanded', 'false');
      });
      body.classList.remove('bsk-mega-open');
    }

    function setMobileMenu(open, trigger = mobileOpen, focusSearch = false, restoreFocus = true) {
      const wasOpen = body.classList.contains('bsk-menu-open');
      body.classList.toggle('bsk-menu-open', open);
      mobileOpen?.setAttribute('aria-expanded', open ? 'true' : 'false');
      mobileSearchTrigger?.setAttribute('aria-expanded', open ? 'true' : 'false');
      mobileMega?.setAttribute('aria-hidden', open ? 'false' : 'true');

      if (open) {
        lastMobileTrigger = trigger;
        window.requestAnimationFrame(() => {
          if (focusSearch) mobileSearchInput?.focus();
          else mobileClose?.focus();
        });
      } else if (wasOpen && restoreFocus) {
        lastMobileTrigger?.focus();
      }
    }

    function setCartDrawer(open) {
      body.classList.toggle('bsk-drawer-open', open);
      cartDrawer?.setAttribute('aria-hidden', open ? 'false' : 'true');
      cartTriggers.forEach((trigger) => trigger.setAttribute('aria-expanded', open ? 'true' : 'false'));
      if (open) {
        closeHeaderSearch();
        closeMegaMenus();
        setMobileMenu(false, mobileOpen, false, false);
      }
    }

    function setCartLoading(loading) {
      header.classList.toggle('is-cart-loading', loading);
      cartDrawer?.setAttribute('aria-busy', loading ? 'true' : 'false');
    }

    function replaceCartDrawer(nextDocument) {
      const nextDrawer = nextDocument.querySelector('[data-bestiksaet-header] #cartDrawer');
      const nextBadge = nextDocument.querySelector('[data-bestiksaet-header] .cart-badge');
      const currentBadge = header.querySelector('.cart-badge');

      if (nextDrawer && cartDrawer) {
        cartDrawer.innerHTML = nextDrawer.innerHTML;
      }

      if (nextBadge && currentBadge) {
        currentBadge.textContent = nextBadge.textContent;
      }
    }

    function updateCartBadge(count) {
      const currentBadge = header.querySelector('.cart-badge');
      if (!currentBadge) return;
      currentBadge.textContent = String(count || 0);
    }

    async function refreshCartDrawer() {
      const response = await fetch(window.location.href, {
        headers: { 'Accept': 'text/html' },
        cache: 'no-store'
      });

      if (!response.ok) return;

      const html = await response.text();
      const nextDocument = new DOMParser().parseFromString(html, 'text/html');
      replaceCartDrawer(nextDocument);
    }

    async function refreshCartState() {
      const cartResponse = await fetch('/cart.js', {
        headers: { 'Accept': 'application/json' },
        cache: 'no-store'
      });

      if (cartResponse.ok) {
        const cart = await cartResponse.json();
        updateCartBadge(cart.item_count);
      }

      await refreshCartDrawer();
    }

    async function runCartRequest(request) {
      if (cartRequest) cartRequest.abort();
      cartRequest = new AbortController();
      setCartLoading(true);

      try {
        const response = await request(cartRequest.signal);
        if (response && !response.ok) throw new Error('Cart request failed');
        await refreshCartState();
        setCartDrawer(true);
      } catch (error) {
        if (error.name !== 'AbortError') {
          window.location.href = '/cart';
        }
      } finally {
        setCartLoading(false);
        cartRequest = undefined;
      }
    }

    function setupHeaderSearch() {
      if (!predictiveSearch) return;

      const input = predictiveSearch.querySelector('[data-header-search-input]');
      const results = predictiveSearch.querySelector('[data-header-search-results]');
      const resultsList = predictiveSearch.querySelector('[data-header-search-results-list]');
      const viewAll = predictiveSearch.querySelector('[data-header-search-view-all]');
      if (!input || !results || !resultsList || !viewAll) return;

      const predictiveUrl = predictiveSearch.dataset.predictiveUrl;
      const searchUrl = predictiveSearch.dataset.searchUrl || '/search';
      const currency = predictiveSearch.dataset.currency || 'DKK';
      const noResults = predictiveSearch.dataset.noResults || 'No products found';
      let searchTimer;
      let searchRequest;
      let priceFormatter;

      try {
        priceFormatter = new Intl.NumberFormat(document.documentElement.lang || 'da-DK', {
          style: 'currency',
          currency
        });
      } catch (error) {
        priceFormatter = undefined;
      }

      function formatPrice(value) {
        const amount = Number(value);
        if (!Number.isFinite(amount)) return '';
        return priceFormatter ? priceFormatter.format(amount) : `${amount.toFixed(2)} ${currency}`;
      }

      closeHeaderSearch = () => {
        results.hidden = true;
        input.setAttribute('aria-expanded', 'false');
        input.removeAttribute('aria-activedescendant');
      };

      function createResult(product, index) {
        const link = document.createElement('a');
        link.className = 'header-search-result';
        link.href = product.url;
        link.id = `bsk-search-result-${index}`;
        link.setAttribute('role', 'option');

        const media = document.createElement('span');
        media.className = 'header-search-result-image';
        if (product.image) {
          const image = document.createElement('img');
          image.src = product.image;
          image.alt = product.title || '';
          image.loading = 'lazy';
          media.append(image);
        }

        const copy = document.createElement('span');
        copy.className = 'header-search-result-copy';
        if (product.vendor) {
          const vendor = document.createElement('small');
          vendor.textContent = product.vendor;
          copy.append(vendor);
        }
        const title = document.createElement('strong');
        title.textContent = product.title || '';
        copy.append(title);

        const price = document.createElement('span');
        price.className = 'header-search-result-price';
        price.textContent = formatPrice(product.price);

        link.append(media, copy, price);
        return link;
      }

      function showResults(products, query) {
        resultsList.replaceChildren();
        viewAll.href = `${searchUrl}?q=${encodeURIComponent(query)}&type=product`;
        viewAll.hidden = products.length === 0;

        if (products.length === 0) {
          const empty = document.createElement('p');
          empty.className = 'header-search-no-results';
          empty.textContent = noResults;
          resultsList.append(empty);
        } else {
          products.slice(0, 6).forEach((product, index) => resultsList.append(createResult(product, index)));
        }

        results.hidden = false;
        input.setAttribute('aria-expanded', 'true');
      }

      async function requestResults(query) {
        if (!predictiveUrl) return;
        if (searchRequest) searchRequest.abort();
        searchRequest = new AbortController();
        input.setAttribute('aria-busy', 'true');

        const url = new URL(predictiveUrl, window.location.origin);
        url.searchParams.set('q', query);
        url.searchParams.set('resources[type]', 'product');
        url.searchParams.set('resources[limit]', '6');
        url.searchParams.set('resources[options][unavailable_products]', 'last');

        try {
          const response = await fetch(url, {
            headers: { 'Accept': 'application/json' },
            signal: searchRequest.signal
          });
          if (!response.ok) throw new Error('Predictive search request failed');
          const data = await response.json();
          showResults(data.resources?.results?.products || [], query);
        } catch (error) {
          if (error.name !== 'AbortError') closeHeaderSearch();
        } finally {
          input.removeAttribute('aria-busy');
        }
      }

      input.addEventListener('input', () => {
        window.clearTimeout(searchTimer);
        const query = input.value.trim();
        if (!query) {
          searchRequest?.abort();
          closeHeaderSearch();
          return;
        }
        searchTimer = window.setTimeout(() => requestResults(query), 180);
      });

      input.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          closeHeaderSearch();
          return;
        }
        if (event.key === 'ArrowDown') {
          const firstResult = resultsList.querySelector('.header-search-result');
          if (firstResult) {
            event.preventDefault();
            firstResult.focus();
          }
        }
      });

      predictiveSearch.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
        const links = Array.from(results.querySelectorAll('a:not([hidden])'));
        const currentIndex = links.indexOf(document.activeElement);
        if (currentIndex < 0) return;
        event.preventDefault();
        const direction = event.key === 'ArrowDown' ? 1 : -1;
        const nextIndex = (currentIndex + direction + links.length) % links.length;
        links[nextIndex]?.focus();
      });

      predictiveSearch.addEventListener('focusout', () => {
        window.setTimeout(() => {
          if (!predictiveSearch.contains(document.activeElement)) closeHeaderSearch();
        }, 0);
      });

      document.addEventListener('pointerdown', (event) => {
        if (!predictiveSearch.contains(event.target)) closeHeaderSearch();
      });
    }

    function setupMega(wrap) {
      const trigger = wrap.querySelector('.nav-item');
      const brandButtons = Array.from(wrap.querySelectorAll('[data-brand-index]'));
      const defaultPanel = wrap.querySelector('[data-default-panel]');
      const panels = Array.from(wrap.querySelectorAll('[data-series-panel]'));
      let closeTimer;
      let resetTimer;
      let hoverTimer;

      function showDefault() {
        brandButtons.forEach((button) => button.classList.remove('is-active'));
        panels.forEach((panel) => {
          panel.classList.remove('is-visible', 'is-changing');
          panel.setAttribute('aria-hidden', 'true');
        });
        defaultPanel?.classList.add('is-default');
      }

      function showPanel(index) {
        window.clearTimeout(resetTimer);
        defaultPanel?.classList.remove('is-default');
        brandButtons.forEach((button) => button.classList.toggle('is-active', button.dataset.brandIndex === String(index)));
        panels.forEach((panel) => {
          const active = panel.dataset.seriesPanel === String(index);
          panel.classList.toggle('is-visible', active);
          panel.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
      }

      function open() {
        window.clearTimeout(closeTimer);
        closeHeaderSearch();
        megaWraps.forEach((other) => {
          if (other === wrap) return;
          other.classList.remove('is-open');
          other.querySelector('.nav-item')?.setAttribute('aria-expanded', 'false');
        });
        wrap.classList.add('is-open');
        trigger?.setAttribute('aria-expanded', 'true');
        body.classList.add('bsk-mega-open');
        body.classList.remove('bsk-drawer-open', 'bsk-menu-open');
      }

      function close() {
        window.clearTimeout(closeTimer);
        closeTimer = window.setTimeout(() => {
          wrap.classList.remove('is-open');
          trigger?.setAttribute('aria-expanded', 'false');
          body.classList.remove('bsk-mega-open');
          showDefault();
        }, 140);
      }

      brandButtons.forEach((button) => {
        const index = button.dataset.brandIndex;
        button.addEventListener('pointerenter', (event) => {
          if (event.pointerType && event.pointerType !== 'mouse') return;
          window.clearTimeout(hoverTimer);
          hoverTimer = window.setTimeout(() => showPanel(index), 180);
        });
        button.addEventListener('pointerleave', () => window.clearTimeout(hoverTimer));
        button.addEventListener('focus', () => showPanel(index));
        button.addEventListener('click', () => showPanel(index));
      });

      wrap.querySelector('.chapter')?.addEventListener('pointerenter', showDefault);
      wrap.addEventListener('pointerenter', open);
      wrap.addEventListener('pointerleave', close);
      wrap.addEventListener('focusin', open);
      wrap.addEventListener('focusout', (event) => {
        if (!wrap.contains(event.relatedTarget)) close();
      });
      trigger?.addEventListener('click', open);
      wrap.addEventListener('bsk:open-mega', open);
    }

    setupHeaderSearch();
    megaWraps.forEach(setupMega);
    document.addEventListener('click', (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;
      const opener = target.closest('[data-bsk-open-mega="collections"]');
      if (!opener || window.matchMedia('(max-width: 900px)').matches) return;

      const collectionsMega = megaWraps[0];
      if (!collectionsMega) return;

      event.preventDefault();
      let hasOpened = false;
      let fallbackTimer;

      const openMega = () => {
        if (hasOpened) return;
        hasOpened = true;
        window.clearTimeout(fallbackTimer);
        window.removeEventListener('scrollend', openMega);
        collectionsMega.dispatchEvent(new CustomEvent('bsk:open-mega'));
      };

      if (window.scrollY <= 2) {
        openMega();
        return;
      }

      window.addEventListener('scrollend', openMega, { once: true });
      window.scrollTo({ top: 0, behavior: 'smooth' });
      fallbackTimer = window.setTimeout(openMega, 900);
    });
    cartTriggers.forEach((trigger) => trigger.addEventListener('click', () => setCartDrawer(!body.classList.contains('bsk-drawer-open'))));
    cartDrawer?.addEventListener('click', (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;

      if (target.closest('.cart-close')) {
        event.preventDefault();
        setCartDrawer(false);
        return;
      }

      const link = target.closest('a[href*="/cart/change"]');
      if (!link) return;

      event.preventDefault();
      const changeUrl = new URL(link.href);
      if (!changeUrl.pathname.endsWith('.js')) {
        changeUrl.pathname = changeUrl.pathname.replace(/\/cart\/change$/, '/cart/change.js');
      }

      runCartRequest((signal) => fetch(changeUrl.href, {
        method: 'GET',
        headers: { 'Accept': 'application/json' },
        signal
      }));
    });
    document.addEventListener('submit', (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!form.matches('form[action*="/cart/add"], form[data-type="add-to-cart-form"]')) return;
      if (form.closest('product-form-component')) return;

      event.preventDefault();
      const submitter = event.submitter;
      if (submitter) submitter.setAttribute('aria-busy', 'true');

      runCartRequest((signal) => fetch(form.action || '/cart/add', {
        method: 'POST',
        body: new FormData(form),
        headers: { 'Accept': 'application/json' },
        signal
      })).finally(() => {
        if (submitter) submitter.removeAttribute('aria-busy');
      });
    }, true);
    document.addEventListener('cart:update', (event) => {
      if (event.detail?.data?.didError) return;
      refreshCartState().then(() => setCartDrawer(true));
    });
    document.addEventListener('cart:refresh', () => {
      refreshCartState();
    });
    dim?.addEventListener('click', () => {
      closeMegaMenus();
      setCartDrawer(false);
    });
    mobileOpen?.addEventListener('click', () => {
      setMobileMenu(true, mobileOpen);
    });
    mobileSearchTrigger?.addEventListener('click', () => {
      setMobileMenu(true, mobileSearchTrigger, true);
    });
    mobileClose?.addEventListener('click', () => {
      setMobileMenu(false);
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeHeaderSearch();
        closeMegaMenus();
        setCartDrawer(false);
        setMobileMenu(false);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bestiksaet-series-collection"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    const trigger = event.target.closest('[data-bsk-series-film-trigger]');
    if (!trigger) return;

    const story = trigger.closest('[data-bsk-series-story]');
    const video = story?.querySelector('[data-bsk-series-film-video]');
    const youtube = story?.querySelector('[data-bsk-series-film-youtube]');
    const hasNativeVideo = video instanceof HTMLVideoElement;
    const hasYoutubeVideo = youtube instanceof HTMLIFrameElement;
    if (!hasNativeVideo && !hasYoutubeVideo) return;

    const youtubeSource = hasYoutubeVideo ? youtube.getAttribute('data-src') : '';
    if (hasYoutubeVideo && !youtubeSource) return;

    const poster = story.querySelector('[data-bsk-series-film-poster]');
    const media = poster?.closest('.bsk-series-film');
    const wasKeyboardTriggered = trigger.matches(':focus-visible');
    poster?.setAttribute('hidden', '');
    media?.classList.add('is-playing');

    let player = video;
    let playPromise;

    if (hasNativeVideo) {
      playPromise = video.play();
    } else {
      const youtubePoster = story.querySelector('.bsk-series-film__youtube-poster');
      youtubePoster?.setAttribute('hidden', '');
      youtube.setAttribute('src', `${youtubeSource}&autoplay=1`);
      youtube.removeAttribute('hidden');
      player = youtube;
    }

    if (wasKeyboardTriggered) player.focus({ preventScroll: true });

    if (!trigger.hasAttribute('data-bsk-series-film-poster')) {
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      player.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
    }

    playPromise?.catch(() => {
      poster?.removeAttribute('hidden');
      media?.classList.remove('is-playing');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
